var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { notificationAtom } from "../../atoms";
import { Notification } from "./Notification";

const NotificationsContainer = () => {
  const timeout = 6000;
  const [timerId, setTimerId] = useState();
  const notification = useRecoilValue(notificationAtom);
  const resetRecoilAtom = useResetRecoilState(notificationAtom);
  const notificationIsSet = Boolean(notification.text && notification.type);

  useEffect(() => {
    if (notificationIsSet && !timerId) {
      const timer = setTimeout(() => {
        resetRecoilAtom();
      }, timeout);

      setTimerId(timer);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
        setTimerId(undefined);
      }
    };
  }, [resetRecoilAtom, notificationIsSet, timerId]);

  const onClickHandler = () => {
    resetRecoilAtom();
  };

  const handleMouseEnter = () => timerId && clearTimeout(timerId);

  const handleMouseLeave = () => {
    if (timerId) clearTimeout(timerId);

    const timer = setTimeout(() => {
      resetRecoilAtom();
    }, timeout);

    setTimerId(timer);
  };

  if (!notificationIsSet) {
    return /*#__PURE__*/_jsx("div", {});
  }

  return /*#__PURE__*/(
    _jsx("div", { className: "tw-content" }, void 0, /*#__PURE__*/
    _jsx("div", {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      className: "fixed bottom-1 left-2 md:w-2/5 w-4/5 z-10" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "shadow-lg", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Notification, {
      type: notification.type,
      text: notification.text,
      details: notification.details,
      heading: notification.heading,
      dismissAction: onClickHandler }
    )
    )
    )
    ));

};

export { NotificationsContainer };